/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Regulamin wyciągu') {
            document.title = 'Regulamin wyciągu';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>REGULAMIN korzystania z wyciągów i tras narciarskich/ snowboardowych</b></Typography>
                <Typography variant='h6' align="center"><b>Kompleksu Rekreacyjno Wypoczynkowego Lesko Summer & Ski sp. z o.o.</b></Typography>
                <br />
                <Typography variant='h6' align="center">Postanowienia ogólne</Typography><br />
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Korzystanie z urządzeń transportu linowego i tras narciarskich/ snowboardowych odbywa się w godzinach otwarcia na podstawie wykupionej karty magnetycznej/biletu.</Typography></li> 
                    <li><Typography variant='body2' gutterBottom>Zakup karty magnetycznej/biletu oznacza akceptację niniejszego regulaminu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Przez bramkę przy wykorzystaniu jednego otwarcia może przejść tylko jedna osoba. Przejazd uważa się za rozpoczęty gdy karta magnetyczna/bilet zostanie skasowana przez czytnik.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Osoby przebywające na terenie kompleksu Lesko Summer & Ski odpowiedzialne są za własne zachowanie oraz używany sprzęt.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Osoby do ukończenia 16 roku życia uprawiające narciarstwo/snowboarding zobowiązane są do używania kasków ochronnych.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Na terenie kompleksu Lesko Summer & Ski obowiązuje bezwzględny zakaz korzystania z wyciągów i tras narciarskich/snowboardowych przez osoby znajdujące się w stanie nietrzeźwości lub pod wpływem środków odurzających i substancji psychoaktywnych.</Typography></li>
                </ol>
                <br />
                <Typography variant='h6' align="center">Zasady korzystania z wyciągów i tras narciarskich/snowboradowych</Typography>
                <br />
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Z wyciągów i tras narciarskich/snowboardowych mogą korzystać osoby posiadające co najmniej podstawowe umiejętności jazdy na nartach lub desce snowboardowej.</Typography></li> 
                    <li><Typography variant='body2' gutterBottom>Po przejściu przez bramkę należy ustawić się w wyznaczonym miejscu -peronie podczepienia i poczekać na urządzenie holujące.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Na urządzeniu holującym może znajdować się tylko jedna osoba. Na podjeździe należy jechać na wprost. Nie wolno zjeżdżać na boki (slalomem), a w razie upadku należy niezwłocznie puścić urządzeni holujące i usunąć się z podjazdu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zabrania się : wczepiania poza strefą wyznaczoną, dotykania innych elementów wyciągów.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W oznaczonej strefie wysiadania należy delikatnie wypuścić urządzenie holujące. Zabrania się rzucania i rozkołysania urządzenia holującego.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Strefę wysiadania należy jak najszybciej opuścić w nakazanym kierunku.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zabrania się kontynuowania jazdy poza strefą wysiadania. W przypadku zatrzymania wyciągu należy spokojnie oczekiwać na jego ponowne uruchomienie lub zastosować się do poleceń obsługi.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Wszyscy narciarze i snowboardziści zobowiązani są do zjeżdżania tylko po wyznaczonych trasach. Na trasach obowiązuje kodeks narciarski FIS (tablica obok) z którym należy się zapoznać przed rozpoczęciem jazdy oraz bezwzględnie przestrzegać.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Snowpark jest pod nadzorem Szkółki Snowboardowej znajdującej się na terenie Kompleksu Lesko Summer & Ski , z którą każdorazowo należy uzgadniać chęć z jego korzystania. Regulamin Snowparku dostępny jest w Szkółce Snowboardowej.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zabrania się wjazdu na trasy narciarskie/snowboradowe wszelkiego rodzaju urządzeń, pojazdów silnikowych za wyjątkiem obsługi wyciągu i służb ratunkowych.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W przypadku niejasności obsługa udzieli pełnych informacji. Obsługa ma prawo do usunięcia z terenu Kompleksu Rekreacyjno -Wypoczynkowego Lesko Summer & Ski osoby  nie stosujące się do powyższego regulaminu.</Typography></li>
                </ol>
                <br />
                <br />
                <Typography variant='h6' align="center">Zasady korzystania z przenośnika taśmowego</Typography>
                <br />
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Klient korzysta z urządzeń z własnej woli i na własne ryzyko.</Typography></li> 
                    <li><Typography variant='body2' gutterBottom>Należy stosować się do poleceń obsługi.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Korzystanie z przenośnika taśmowego możliwe jest tylko w obecności obsługi.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Dzieci poniżej 5 lat mogą korzystać z urządzenia tylko pod opieką osoby pełnoletniej, zdolnej do udzielenia ewentualnej pomocy. Za szkody wyrządzone przez dzieci odpowiadają rodzice.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zabrania się jazdy przenośnikiem taśmowym w dwie osoby naraz obok siebie, należy zachować bezpieczny odstęp.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Taśma nie jest przystosowana do przewozu osób niepełnosprawnych.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Narty, sanki, deski snowboardowe, pontony należy ułożyć płasko na taśmie wzdłuż toru.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Po zatrzymaniu taśmy należy czekać na polecenia obsługi lub wznowienie jazdy.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Po zakończeniu jazdy przenośnikiem należy niezwłocznie opuścić taśmę.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Personel nadzorujący ma prawo, w razie konieczności, do natychmiastowego zamknięcia taśmy bez podania przyczyny.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Obsługa ma prawo usunąć z terenu przenośnika osoby nietrzeźwe, będące pod wpływem działania środków odurzających, a także osoby nieprzestrzegające regulaminu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Wszelkie uszkodzenia urządzeń i inne nieprawidłowości należy bezzwłocznie zgłaszać obsłudze.</Typography></li>
                </ol>
                <br />
                <Typography variant='h6' align="center">Zabrania się</Typography>
                <br />
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Przejazdu dzieci poniżej 5 lat bez opieki osoby pełnoletniej.</Typography></li> 
                    <li><Typography variant='body2' gutterBottom>Korzystania z taśmy przez osoby znajdujące się pod wpływem alkoholu lub środków odurzających.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Niszczenia urządzenia.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zaśmiecania terenu — prosimy o wrzucanie odpadków do koszy na śmieci.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Wprowadzania zwierząt bez smyczy i kagańca.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Na terenie, w którym znajduje się urządzenie obowiązuje bezwzględny zakaz palenia.</Typography></li>
                </ol>


                <br />
                <Typography variant='body2' gutterBottom style={{  textAlign: "center" }} >W przypadku niejasności obsługa udzieli pełnych informacji. Obsługa ma prawo do usunięcia z terenu Kompleksu Rekreacyjno -Wypoczynkowego Lesko Summer & Ski osoby  nie stosujące się do powyższego regulaminu.</Typography>
                <br />
                <Typography variant='body2' gutterBottom style={{ fontSize: '16px', textAlign: "center" }}><b>Życzymy bezpiecznej i przyjemnej jazdy :{")"}</b></Typography>
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    noMarginTop: {
        marginTop: 0,
    },
    noMarginBottom: {
        marginBottom: 0,
    },
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    email: {
        //color: "inherit",
        color: '#3a87ad',
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
});

export default withStyles(styles)(HotelTest);
